/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {
  getLossList,getLossListForDealer
} from "@/api/Loss"

export default {
  addLoss({
    commit
  }, loss) {
    return new Promise((resolve, reject) => {
      commit('ADD_LOSS', loss)
      resolve()
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchDataListItemsLoss({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      getLossList(payload)
        .then((response) => {
          if (response.status === 200) {
            commit('SET_LOSSES', response.data);
            resolve(response);
          } else {
            reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
          }

        })
        .catch(error => {
          
          reject(new Error("Sunucu Bağlantısı Başarısız !"));
        })
    })
  },
  fetchDataListItemsLossForDealer({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      getLossListForDealer(payload)
        .then((response) => {
          if (response.status === 200) {
            commit('SET_LOSSES', response.data);
            resolve(response);
          } else {
            reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
          }

        })
        .catch(error => {
          
          reject(new Error("Sunucu Bağlantısı Başarısız !"));
        })
    })
  },
  updateLoss({
    commit
  }, loss) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_LOSS', loss)
      resolve()
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeLoss({
    commit
  }, lossId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_LOSS', lossId)
      resolve()
        .catch((error) => {
          reject(error)
        })
    })
  },
  openLossEntries({
    commit
  }, lossIndex) {
    return new Promise((resolve, reject) => {
      commit('OPEN_LOSS', lossIndex)
      resolve()
        .catch((error) => {
          reject(error)
        })
    })
  },
};
